import { Controller } from '@hotwired/stimulus';

export default class MerchandisePurchaseQuantity extends Controller {
  static targets = [
    'quantity',
    'totalAmount'
  ];

  static values = {
    amount: Number
  }

  connect() {
    this.changeQuantity();
  }

  changeQuantity() {
    const quantity = Number(this.quantityTarget.value);
    this.totalAmountTarget.textContent = Intl.NumberFormat('ja-JP').format(this.amountValue * quantity);
  }
}
